import railsAxios from '../../../lib/railsAxios';
import { trackPageSubmit } from '../../../tracking/adobe';
import updateDataAnalyticsLayer from '../../../tracking/adobe/updateDataAnalyticsLayer';

const submitRegPage = async ({ commit, dispatch }, payload, submitPath) => {
  commit('SET_SUBMITTING_REG_DATA', true);
  trackPageSubmit(submitPath);
  try {
    const response = await railsAxios.post(submitPath, payload);
    const { data, errors } = response.data;

    if (!errors) {
      commit('SET_BACKEND_ERRORS', null, { root: true });
      commit('SET_BACKEND_ERROR_MESSAGES', null, { root: true });
      dispatch('mergeState', data, { root: true });
    } else {
      commit('SET_BACKEND_ERRORS', errors, { root: true });
      commit('SET_BACKEND_ERROR_MESSAGES', data, { root: true });
    }

    if (data.data_layer) {
      await updateDataAnalyticsLayer(data.data_layer);
    }

    return response;
  } catch (error) {
    let errorMsg = '';
    const errorResponse = error.response;

    if (errorResponse) {
      const { data } = errorResponse.data;
      errorMsg = data;
    } else {
      // use default error message
      errorMsg = null;
    }

    await dispatch('setBackendErrorMessage', errorMsg, { root: true });
    return Promise.reject(error);
  } finally {
    commit('SET_SUBMITTING_REG_DATA', false);
  }
};

export default submitRegPage;
